import React, { useRef, useState, useCallback } from "react";
import { Tooltip } from "reactstrap";

type Props = {
  className: string;
  onClick?: () => void;
  tooltip: string;
  value: string
};

export default function TextWithTooltip(props: Props) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const toggleTooltip = useCallback(() => setIsTooltipOpen((prev) => !prev), []);
  const textRef = useRef<HTMLElement | null>(null);

  return (
    <>
      <big className={props.className} onClick={props.onClick} ref={textRef}>{props.value}</big>
      <Tooltip
        className="pointer-events-none"
        target={textRef}
        placement="top"
        innerClassName="py-1"
        isOpen={isTooltipOpen}
        toggle={toggleTooltip}>
        {props.tooltip}
      </Tooltip>
    </>
  );
}
